import { founded_item } from "./index.js";
import { surface_sideDeserializeStep } from "./index.js";
import { surface_side_style } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class surface_style_usage extends founded_item {
    get type() {
        return EntityTypesAP214.SURFACE_STYLE_USAGE;
    }
    get side() {
        if (this.side_ === void 0) {
            this.side_ = this.extractLambda(0, surface_sideDeserializeStep, false);
        }
        return this.side_;
    }
    get style() {
        if (this.style_ === void 0) {
            const value = this.extractReference(1, false);
            if (!(value instanceof surface_side_style)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.style_ = value;
        }
        return this.style_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
surface_style_usage.query = [EntityTypesAP214.SURFACE_STYLE_USAGE];
surface_style_usage.expectedType = EntityTypesAP214.SURFACE_STYLE_USAGE;
